/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'cellphone-play': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M17 19H7V5h10m0-4H7c-1.11 0-2 .89-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3a2 2 0 00-2-2m-7 8v6l4-3-4-3z"/>'
  }
})
